import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { MenuController } from '@ionic/angular';
import { NotificationService } from '@services/notifications.service';
import { StorageService } from '@services/storage.service';
import { Subscription } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {
  @Input() layoutId: string;
  @Input() menuItems: any[];
  // mode = 1;
  userName: string;
  numberNotifications: number = 0;
  private sub: Subscription;


  constructor(
    private router: Router,
    private menu: MenuController,
    private notificationsService: NotificationService,
    private storageService: StorageService,
  ) { }

  ngOnInit() {
    this.sub = this.storageService.getUserNameObservable().subscribe(
      name => this.userName = name
    );
    this.checkNotifications();
  }

  logout() {
    this.storageService.clear();
    this.router.navigateByUrl('auth/login');
  }

  openFirst() {
    this.menu.enable(true, 'first');
    this.menu.open('first');
  }

  checkNotifications() {
    this.notificationsService.notifications.subscribe(
      (data) => this.numberNotifications = data.length
    )
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
